<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div>
      <el-button type="text" v-if="field.options.showSaveTemp" class="momb" @click="saveTemps">另存为模板</el-button>
      <el-button v-if="field.options.supDia" icon="el-icon-document-add" type="text"
        @click="specialDialogVisible = true">选择特殊符号</el-button>
      <el-button v-if="field.options.subDia" icon="el-icon-document-add" type="text"
        @click="supSubDialogVisible = true">选择上下标</el-button>
    </div>
    <save-temp-vue :temp-dialog-visible.sync="tempDialogVisible" :field-model.sync="fieldModel"
      :temp-save-url="field.options.saveTempUrl" :temp-code="field.options.codeValue" :template="template"
      :temp-name="field.options.label"></save-temp-vue>
    <div ref="fieldEditor" :class="{
      'combo-grid-wrap': true,
      'combo-grid-wrap-border': field.options.border,
      'no-focus-input': false,
    }">
      <div v-for="(item, index) of fieldModel" :key="index" style="display: inline-block">
        <div class="value-item" :class="idx == index ? 'hover' : ''" :style="{
          background: field.options.backgroundColor,
          color: field.options.valColor,
          fontSize: field.options.fontSize,
          border: '1px solid ' + field.options.bcolor,
        }" @mouseenter="spanMouseenter(index)" @mouseleave="spanMouseleave">
          {{ index + 1 }}.
          <span :ref="'valueSpan' + index" class="value-item-span" :contenteditable="!field.options.disabled && !field.options.noEditable
            " @blur="saveSpan('valueSpan' + index, index)" v-html="item.trim()" />
          <img class="icon-close" v-if="!field.options.disabled" @click="delSelValue(index)"
            src="../../assets/close.png" />
          <!-- <span
            class="close"
            v-if="!field.options.disabled"
            @click="delSelValue(index)"
          >
            ×
          </span> -->
        </div>
      </div>
      <div ref="searchBox" id="textArea" contenteditable="true" type="text" class="textArea" :style="{
        width: queryStr?'100%':'30%',
      }" style="height: 36px; overflow: hidden" :placeholder="field.options.placeholder"
        :class="field.options.inputClass" :disabled="field.options.disabled" @click="showPanel" @keydown.esc="escFunc"
        @keydown.up="upFunc" @keydown.down="downFunc" @keydown.space="spaceFunc" @keydown.enter="enterFunc"
        @focus="inputFocus" @blur="inputBlur" @input="input" />
      <div ref="showGridPanel" :class="{
        'combGrid-panel': true,
        showGridPanel: (queryStr || showGridPanel)&& flag,
      }" :style="gridPanelStyle">
        <el-table ref="singleTable" :data="listData" border highlight-current-row :height="field.options.tableHeight"
          class="combogrid-grid-table" @row-click="tableRowClick">
          <el-table-column label="NO" type="index" :index="indexMethod" :show-overflow-tooltip="true" />
          <el-table-column prop="templateType" label="类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.templateType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="模板标题" show-overflow-tooltip width="78">
            <template slot-scope="scope">
              <span>{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="模板内容" show-overflow-tooltip width="292">
            <template slot-scope="scope">
              <span>{{ scope.row.content }}</span>
            </template>
          </el-table-column>
          <!-- <slot
            name="tableColumns"
            v-if="$slots.tableColumns"
            ></slot> -->
        </el-table>
        <el-pagination :page-size="pageSize" :total="total" :current-page.sync="current" layout="prev,pager,next"
          :page-sizes="[pageSize]" @current-change="currentPageChange" />
      </div>
    </div>
    <!-- 选择特殊符号弹出框 -->
    <el-dialog title="选择特殊符号" :append-to-body="true" :visible.sync="specialDialogVisible" width="600px">
      <div class="jdialog-content special">
        <el-checkbox-group v-model="specialCodes">
          <el-checkbox v-for="dic in specialCodeArray" :key="dic.dicKey" :label="dic.dicValue" :value="dic.dicKey" />
        </el-checkbox-group>
      </div>
      <div class="jdialog-footer">
        <el-button type="primary" @click="toSpecialCodes">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择上下标弹出框 -->
    <el-dialog title="选择上下标" :append-to-body="true" :visible.sync="supSubDialogVisible" width="600px">
      <div class="jdialog-content">
        上标：
        <el-checkbox-group v-model="cfSupCodes">
          <el-checkbox v-for="dic in cfSupArray" :key="dic.dicKey" :label="dic.dicValue" :value="dic.dicKey" />
        </el-checkbox-group>
        下标：
        <el-checkbox-group v-model="cfSubCodes">
          <el-checkbox v-for="dic in cfSubArray" :key="dic.dicKey" :label="dic.dicValue" :value="dic.dicKey" />
        </el-checkbox-group>
      </div>
      <div class="jdialog-footer">
        <el-button type="primary" @click="toSuoSubCodes">确定</el-button>
      </div>
    </el-dialog>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import request from "@/utils/request";
import { deepClone, isNull } from "@/utils/util";
import SaveTempVue from "./saveTemp.vue";
import debounce from "lodash/debounce";
export default {
  name: "comboGridWidget",
  components: {
    FormItemWrapper,
    SaveTempVue,
  },
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel", "globalFormData"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
    filedLabel: {
      type: String,
      default: "title",
    },
    filedContent: {
      type: String,
      default: "content",
    },
  },
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],

      loading: false, // 请求是否加载中
      queryStr: "", // 查询字符串
      listData: [], // 表格当前页数据
      current: 1, // 当前分页页码
      pageSize: 10, // 页面条数
      total: 0, // 总条数
      showGridPanel: false,
      val: "", // el-select选中值
      originalSelectObj: {}, // 原始选中的对象
      selectValue: {},
      currentRow: -1,
      gridPanelStyle: {},
      idx: -1,
      haveData: true,
      workID: "",
      createID: "",
      week: "",
      errClass: false,
      flagFocus: false,
      dycxr: true,
      hheight: "36px",
      tempDialogVisible: false,
      template: {},
      specialDialogVisible: false,
      specialCodes: [],
      specialCodeArray: [],
      supSubDialogVisible: false,
      cfSupCodes: [],
      cfSupArray: [],
      cfSubCodes: [],
      cfSubArray: [],
      insertIndex: -1,
      flag:false
    };
  },
  watch: {
    // 查询条件改变时，重新加载表格数据
    queryStr() {
      this.loadGridData();
      this.cHeight();
    },
    fieldModel(newVal, oldValue) {
      if (newVal == oldValue) return
      if (!newVal) {
        this.fieldModel = []
        this.handleChangeEvent(this.fieldModel)

      } else if (typeof newVal === 'string') {
        this.fieldModel = newVal.split(',').map(item => item.trim());
        this.handleChangeEvent(this.fieldModel)
      }
      if (this.field.options.required && !this.dycxr) {
        this.handleChangeEvent(newVal);
      }
    },
  },
  created() {
    this.registerToRefList();
    this.initEventHandler();
    this.initFieldModel();
    if (this.field.options.required) {
      this.addRuls();
    }
    var dict = JSON.parse(sessionStorage.getItem("nt_dic"));
    // 特殊字符
    this.specialCodeArray = dict.cf_special_code;
    // 护理单上标
    this.cfSupArray = dict.cf_sup;
    // 护理单下标
    this.cfSubArray = dict.cf_sub;
    // 同步方法 查询是否有数据
    //this.getDatas()
  },
  beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    // 导入特殊字符
    toSpecialCodes() {
      // let index = getSelection().getRangeAt(0).startOffset
      // console.log(index);
      const specialCodes = this.specialCodes.join("");
      if (specialCodes) {
        if (this.insertIndex != -1) {
          this.$refs["valueSpan" + this.insertIndex][0].innerHTML =
            this.$refs["valueSpan" + this.insertIndex][0].innerHTML +
            specialCodes;
          this.$refs["valueSpan" + this.insertIndex][0].focus();
        } else {
          this.$refs.searchBox.innerHTML =
            this.$refs.searchBox.innerText + specialCodes;
          // this.$refs.searchBox.focus()
        }
      }
      this.specialCodes = [];
      this.specialDialogVisible = false;
    },
    // 导入上下标
    toSuoSubCodes() {
      // let index = getSelection().getRangeAt(0).startOffset
      // console.log(index);
      const cfSupCodes = this.cfSupCodes.join("");
      if (cfSupCodes) {
        if (this.insertIndex != -1) {
          this.$refs["valueSpan" + this.insertIndex][0].innerHTML =
            this.$refs["valueSpan" + this.insertIndex][0].innerHTML +
            "<SUP>" +
            cfSupCodes +
            "</SUP>&nbsp;";
          this.$refs["valueSpan" + this.insertIndex][0].focus();
        } else {
          this.$refs.searchBox.innerHTML =
            this.$refs.searchBox.innerHTML +
            "<sup>" +
            cfSupCodes +
            "</sup>&nbsp;";
          // this.$refs.searchBox.focus()
        }
      }
      const cfSubCodes = this.cfSubCodes.join("");
      if (cfSubCodes) {
        if (this.insertIndex != -1) {
          this.$refs["valueSpan" + this.insertIndex][0].innerHTML =
            this.$refs["valueSpan" + this.insertIndex][0].innerHTML +
            "<SUB>" +
            cfSubCodes +
            "</SUB>&nbsp;";
          this.$refs["valueSpan" + this.insertIndex][0].focus();
        } else {
          this.$refs.searchBox.innerHTML =
            this.$refs.searchBox.innerHTML +
            "<sub>" +
            cfSubCodes +
            "</sub>&nbsp;";
          // this.$refs.searchBox.focus()
        }
      }
      this.cfSupCodes = [];
      this.cfSubCodes = [];
      this.supSubDialogVisible = false;
    },
    saveTemps() {
      this.tempDialogVisible = true;
    },
    cHeight() {
      if (this.queryStr.length > (this.$refs.searchBox.clientWidth / 14) * 2) {
        this.hheight =
          (this.queryStr.length / (this.$refs.searchBox.clientWidth / 14) + 1) *
          12 +
          "px";
      } else {
        this.hheight = "28px";
      }
    },
    addRuls() {
      let _this = this;
      this.rules.push({
        validator: function (rule, value, callback, errorMsg) {
          if (isNull(value) || value.length <= 0 || value == ",") {
            callback(
              new Error(
                _this.field.options.requiredHint ||
                _this.i18nt("render.hint.fieldRequired")
              )
            );
            return;
          }
          callback();
        },
        trigger: ["blur", "change"],
        label: this.field.options.label,
      });
    },
    indexMethod(index) {
      return index + ((this.current || 1) - 1) * this.pageSize + 1;
    },
    escFunc() {
      // this.showGridPanel = false;
      this.queryStr = "";
      this.$refs.searchBox.blur();
    },
    upFunc() {
      // 向上键
      this.currentRow = this.currentRow - 1;
      if (this.currentRow < 0) {
        this.currentRow = 0;
      }
      this.$refs.singleTable.setCurrentRow(this.listData[this.currentRow]);
    },
    downFunc() {
      // 向下键
      this.currentRow = this.currentRow + 1;
      this.$refs.singleTable.setCurrentRow(this.listData[this.currentRow]);
      if (this.currentRow >= this.listData.length) {
        this.currentRow = -1;
      }
    },
    enterFunc() {
      // enter键
      if (this.currentRow >= 0) {
        this.tableRowClick(this.listData[this.currentRow]);
      } else {
        let queryStr = this.$refs.searchBox.innerHTML;
        this.$refs.searchBox.innerHTML = queryStr.replace("\n", "");
        if (
          this.$refs.searchBox.innerHTML.trim() != "" &&
          this.$refs.searchBox.innerHTML != "<br>" &&
          this.$refs.searchBox.innerHTML != "<div><br></div><div><br></div>"
        ) {
          if (this.field.options.noEditable) return;
          this.tableRowClick({
            [this.filedLabel]: "0",
            [this.filedContent]: this.$refs.searchBox.innerHTML,
          });
        }
      }
      this.delDom();
    },
    delDom() {
      // 获取要删除的节点
      const node = document.getElementById("textArea");
      // 在下一次 DOM 更新后执行删除操作
      this.$nextTick(() => {
        // 获取该节点下的所有子节点
        const childNodes = node.childNodes;
        // 遍历所有子节点，如果是元素节点则移除
        for (let i = childNodes.length - 1; i >= 0; i--) {
          const childNode = childNodes[i];
          if (childNode.nodeType === Node.ELEMENT_NODE) {
            node.removeChild(childNode);
          }
        }
      });
      this.$refs.searchBox.innerHTML = "";
      this.queryStr = "";
    },
    spaceFunc() {
      this.loadGridData({ detail: "1" });
    },
    showPanel() {
      this.insertIndex = -1;
      if (!this.field.options.needTable) return;
      if (!this.showGridPanel) {
        this.showGridPanel = true;
        this.computePos();
        this.loadGridData();
        addEventListener("click", this.hideSel, true);
        addEventListener("scroll", this.hideSel, true);
      }
    },
    delSelValue(index) {
      var deepArr = deepClone(this.fieldModel);
      // 删除
      deepArr.splice(index, 1);
      if (deepArr.length == 0) this.delDom();
      this.setValue(deepArr);
    },
    // 隐藏选择框
    hideSel(event) {
      if (
        this.$refs.showGridPanel &&
        this.$refs.showGridPanel.contains(event.target)
      ) {
        // 如果是子元素,则阻止事件捕获
        this.$refs.searchBox.focus();
      } else {
        this.enterFunc();
        this.showGridPanel = false;
        removeEventListener("click", this.hideSel, true);
        removeEventListener("scroll", this.hideSel, true);
      }
    },

    currentPageChange() {
      // 分页数据
      this.loadGridData();
    },
    tableRowClick(row) {
      this.$refs.searchBox.innerHTML = "";
      var deepArr = this.fieldModel ? deepClone(this.fieldModel) : [];
      deepArr.push(row[this.filedContent]);
      this.setValue(deepArr);
      this.currentRow = -1;
      this.showGridPanel = false;
      // 只有需要表格的时候才调用
      // if (this.field.options.needTable) {
      this.$refs.searchBox.blur();
      this.queryStr=''
      setTimeout(() => {
        this.$refs.searchBox.focus();
      }, 100);
      // }
    },
    computePos() {
      // 获取元素
      const element = this.$refs.fieldEditor;
      const rect = element.getBoundingClientRect();
      // 获取元素上边框距离页面顶部的高度
      const topOffset = rect.top + window.pageYOffset;
      // 获取元素底部边框距离页面顶部的高度
      const bottomOffset = rect.bottom + window.pageYOffset
      // 计算高度宽度
      const contentHeight =
        this.$refs.showGridPanel.clientHeight == 0
          ? 300
          : this.$refs.showGridPanel.clientHeight; // 内容高度
      const contentWidth =
        this.$refs.showGridPanel.offsetWidth == 0
          ? 450
          : this.$refs.showGridPanel.offsetWidth; // 内容宽度
      const docHeight =
        document.documentElement.clientHeight | document.body.clientHeight || 0; // 窗口高度
      const docWidth =
        document.documentElement.clientWidth || document.body.clientWidth || 0; // 窗口宽度
      const topPosition = this.$refs.searchBox.getBoundingClientRect().top;
      let leftPosition = this.$refs.searchBox.getBoundingClientRect().left;
      if (docWidth - leftPosition < contentWidth) {
        // 判断向左偏移位置
        leftPosition = docWidth - contentWidth;
      }
      if (topPosition > docHeight - contentHeight) {
        this.gridPanelStyle = {
          left: leftPosition + "px",
          bottom: docHeight - topOffset + 3+ "px",
        };
      } else {
        this.gridPanelStyle = {
          left: leftPosition + "px",
          top: bottomOffset+3 + "px",
        };
      }
    },
    spanEnter(indexSpan, index) {
      const html = this.$refs[indexSpan][0].innerText;
      var deepArr = deepClone(this.fieldModel);
      deepArr[index] = html;
      this.setValue(deepArr);
    },
    saveSpan(indexSpan, index) {
      // span 保存修改
      let html = this.$refs[indexSpan][0].innerHTML;
      html = html.toString().replace(/(<div>|<\/div>)/g, "");
      html = html.toString().replace(/\<br\>/g, "\n");
      html = html.toString().replace(/\&lt\;/g, "<");
      html = html.toString().replace(/\&gt\;/g, ">");
      var deepArr = deepClone(this.fieldModel);
      deepArr[index] = html;
      this.setValue(deepArr);
      this.insertIndex = index;
    },
    spanMouseenter(index) {
      this.idx = index;
    },
    spanMouseleave() {
      this.idx = -1;
    },
    loadGridData() {
      // 加载数据
      if (this.showGridPanel) {
        let params = {
          current: this.current,
          size: this.pageSize,
          code: this.field.options.codeValue,
          keywords: this.queryStr.trim(),
        };

        // 孕周
        if (this.field.options.weekCode) {
          if (
            this.globalModel.formModel.hasOwnProperty(
              this.field.options.weekCode
            )
          ) {
            params.week =
              this.globalModel.formModel[this.field.options.weekCode];
          } else if (
            this.globalFormData.hasOwnProperty(this.field.options.weekCode)
          ) {
            params.week = this.globalFormData[this.field.options.weekCode];
          }
        }
        if(window.apiConfig.key!='baoan'){
          this.$http({
            url: this.$http.adornUrl("/ntApi/handleRequest"), // 孕保系统固定请求此地址
            data: this.$http.adornData({
              uri: this.field.options.url, // 实际请求的外部系统api路径
              type: "post",
              params: params,
              hideLoading: true,
            }),
          }).then((response) => {
            this.total = response.data.total ? +response.data.total : 0;
            this.listData = response.data.data ||[];
            if (this.listData.length > 0) {
              // 另存为模板需要的字段值
              this.template = this.listData[0];
              this.flag=true
            }

            if (this.total === 0) {
              this.haveData = false;
            } else {
              this.haveData = true;
            }
          });
        }else{
          this.$http({
            url: this.field.options.url,
            method: 'get',
            hideLoading: true,
            params
          }).then((response) => {
            this.total = response.data.total ? +response.data.total : 0;
            this.listData = response.data.data ||[];
            if (this.listData.length > 0) {
              // 另存为模板需要的字段值
              this.template = this.listData[0];
              this.flag=true
            }

            if (this.total === 0) {
              this.haveData = false;
            } else {
              this.haveData = true;
            }
          });
        }
      }
    },
    input() {
      if (this.$refs.searchBox.innerHTML.indexOf("<br>") > -1) {
        this.$refs.searchBox.innerHTML = this.$refs.searchBox.innerHTML.replace(
          "<br>",
          ""
        );
      }
      this.queryStr = this.$refs.searchBox.innerHTML;
      this.computePos();
    },
    inputFocus() {
      this.flagFocus = true;
    },
    inputBlur() {
      this.flagFocus = false;
      this.dycxr = false;
      if (this.field.options.required) {
        this.handleChangeEvent(this.fieldModel);
      }
      // this.$refs.searchBox.innerText = ''
    },
  },
};
</script>

<style lang="scss">
.el-pager {
  line-height: 28px;
}

.el-pager li.active+li {
  border: none;
}

.el-pager li {
  border: none;
}
</style>
<style lang="scss">
:root {
  --global-color: #5d7078;
  /*全局基本字体颜色*/
  --table-input-border-color: #c5c5c5;
  /*input 边框色*/
  --global-font-size: 12px;
  /*全局基本字体大小*/
  --title-bg-color: #ebeef5;
  /*title背景色*/
}

.combo-grid-wrap {
  padding: 5px 10px;
  border: 1px solid #c5c5c5;
  min-height: 56px;
  height: auto;
  background-color: #fff;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
}

.combo-grid-wrap-border {
  border: 1px solid #c5c5c5;
}

.icon-close {
  // position: absolute;
  // top: 4px;
  cursor: pointer;
  margin-left: 5px;
  vertical-align: middle;
  transform: scale(0.9);
}

.combGrid-panel {
  position: fixed;
  display: none;
}

.showGridPanel {
  display: block;
  z-index: 1111;
}

.no-border-input {
  border: none;
  height: 30px;
  outline: none;
  font-size: 12px;
}

.value-item {
  position: relative;
  display: inline-block;
  line-height: 20px;
  padding: 1px 4px;
  margin-top: 3px;
  margin-right: 10px;
  height: auto !important;
  font-size: 12px;
  color: #5d7078;
  word-break: break-all;
}

.hover .close {
  // display: inline-block;
}

.value-item-span {
  white-space: pre-wrap;
}

.combGrid-panel .el-table td,
.el-table th,
.combGrid-panel .el-table--small .el-table__cell {
  padding: 0;
}

.combGrid-panel.el-pagination {
  text-align: right;
}

.combGrid-panel .el-table th.el-table__cell {
  background: #eaeaea;
}

.combo-grid-wrap .el-pagination {
  background: #ebeef5;
}

.combo-grid-wrap .el-pagination button:disabled,
.combo-grid-wrap .el-pagination button {
  background-color: #ebeef5;
}

.combo-grid-wrap .el-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.is-error .combo-grid-wrap,
.is-error.combo-grid-wrap {
  border: 1px solid #f56c6c;
}

.no-focus-css+.el-form-item__error {
  display: none;
}

.momb {
  color: #409eff;
  line-height: 20px;
  font-size: 13px;
  cursor: pointer;
}

.textArea {
  cursor: pointer;
  resize: none;
}

::v-deep .el-table__header-wrapper {
  height: 30px;
}

.textArea:empty::before {
  content: attr(placeholder);
  color: #cccccc;
}

.special .el-checkbox__label {
  min-width: 24px;
}
</style>
